<!-- Distillation Funnel -->
<div class="distillation-funnel-container container-fluid">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h2 class="mb-0">Email Security Distillation Pipeline</h2>
  </div>
  <div class="distillation-funnel row g-3 mb-5">
    <!-- Total Ingested Events -->
    <div class="funnel-stage raw-events col position-relative">
      <div class="stage-content card h-100">
        <div class="card-body text-center">
          <div class="stage-icon mb-2">
            <i class="fas fa-database"></i>
          </div>
          <div class="stage-metrics">
            <div class="stage-title text-secondary mb-2">Total Email Volume</div>
            <div class="stage-value h2 mb-2">
              {{ emailFunnel().total_email_volume | number }}
            </div>
            <div
              class="stage-comparison small"
              [class.text-success]="
                (emailFunnel().total_email_volume !== null ? emailFunnel().total_email_volume : 0) >
                (emailFunnel().total_email_volume_previous !== null ? emailFunnel().total_email_volume_previous : 0)
              "
              [class.text-danger]="
                (emailFunnel().total_email_volume !== null ? emailFunnel().total_email_volume : 0) <
                (emailFunnel().total_email_volume_previous !== null ? emailFunnel().total_email_volume_previous : 0)
              "
            >
              @if (
                (emailFunnel().total_email_volume !== null ? emailFunnel().total_email_volume : 0) >
                (emailFunnel().total_email_volume_previous !== null ? emailFunnel().total_email_volume_previous : 0)
              ) {
                <span>↑</span>
              }
              @if (
                (emailFunnel().total_email_volume !== null ? emailFunnel().total_email_volume : 0) <
                (emailFunnel().total_email_volume_previous !== null ? emailFunnel().total_email_volume_previous : 0)
              ) {
                <span>↓</span>
              }
              {{ (emailFunnel().total_email_volume_pct_change ?? 0) | number: '1.1-1' }}% vs previous
            </div>
          </div>
        </div>
      </div>
      <div class="funnel-connector">
        <div class="connector-arrow"></div>
      </div>
    </div>

    <!-- Consolidated Cases -->
    <div class="funnel-stage detections col position-relative">
      <div class="stage-content card h-100">
        <div class="card-body text-center">
          <div class="stage-icon mb-2">
            <img
              src="assets/icons/detection-icon.png"
              alt="Detection Icon"
              width="24"
              height="24"
            />
          </div>
          <div class="stage-metrics">
            <div class="stage-title text-secondary mb-2">Threats Detected</div>
            <div class="stage-value h2 mb-2">
              {{ emailFunnel().total_threats_detected | number }}
            </div>
            <div
              class="stage-comparison small"
              [class.text-success]="
                (emailFunnel().total_threats_detected !== null ? emailFunnel().total_threats_detected : 0) >
                (emailFunnel().total_threats_detected_previous !== null
                  ? emailFunnel().total_threats_detected_previous
                  : 0)
              "
              [class.text-danger]="
                (emailFunnel().total_threats_detected !== null ? emailFunnel().total_threats_detected : 0) <
                (emailFunnel().total_threats_detected_previous !== null
                  ? emailFunnel().total_threats_detected_previous
                  : 0)
              "
            >
              @if (
                (emailFunnel().total_threats_detected !== null ? emailFunnel().total_threats_detected : 0) >
                (emailFunnel().total_threats_detected_previous !== null
                  ? emailFunnel().total_threats_detected_previous
                  : 0)
              ) {
                <span>↑</span>
              }
              @if (
                (emailFunnel().total_threats_detected !== null ? emailFunnel().total_threats_detected : 0) <
                (emailFunnel().total_threats_detected_previous !== null
                  ? emailFunnel().total_threats_detected_previous
                  : 0)
              ) {
                <span>↓</span>
              }
              {{ (emailFunnel().total_threats_detected_pct_change ?? 0) | number: '1.1-1' }}% vs previous
            </div>
          </div>
        </div>
      </div>
      <div class="funnel-connector">
        <div class="connector-arrow"></div>
      </div>
    </div>

    <!-- Escalations -->
    <div class="funnel-stage escalations col position-relative">
      <div class="stage-content card h-100">
        <div class="card-body text-center">
          <div class="stage-icon mb-2">
            <i class="fas fa-exclamation-triangle"></i>
          </div>
          <div class="stage-metrics">
            <div class="stage-title text-secondary mb-2">Threats Blocked</div>
            <div class="stage-value h2 mb-2">
              {{ emailFunnel().total_threats_blocked | number }}
            </div>
            <div
              class="stage-comparison small"
              [class.text-success]="
                (emailFunnel().total_threats_blocked !== null ? emailFunnel().total_threats_blocked : 0) <
                (emailFunnel().total_threats_blocked_previous !== null
                  ? emailFunnel().total_threats_blocked_previous
                  : 0)
              "
              [class.text-danger]="
                (emailFunnel().total_threats_blocked !== null ? emailFunnel().total_threats_blocked : 0) >
                (emailFunnel().total_threats_blocked_previous !== null
                  ? emailFunnel().total_threats_blocked_previous
                  : 0)
              "
            >
              @if (
                (emailFunnel().total_threats_blocked !== null ? emailFunnel().total_threats_blocked : 0) <
                (emailFunnel().total_threats_blocked_previous !== null
                  ? emailFunnel().total_threats_blocked_previous
                  : 0)
              ) {
                <span>↓</span>
              }
              @if (
                (emailFunnel().total_threats_blocked !== null ? emailFunnel().total_threats_blocked : 0) >
                (emailFunnel().total_threats_blocked_previous !== null
                  ? emailFunnel().total_threats_blocked_previous
                  : 0)
              ) {
                <span>↑</span>
              }
              {{ (emailFunnel().total_threats_blocked_pct_change ?? 0) | number: '1.1-1' }}% vs previous
            </div>
          </div>
        </div>
      </div>
      <div class="funnel-connector">
        <div class="connector-arrow"></div>
      </div>
    </div>

    <!-- Incidents -->
    <div class="funnel-stage incidents col">
      <div class="stage-content card h-100">
        <div class="card-body text-center">
          <div class="stage-icon mb-2">
            <i class="fas fa-shield-alt"></i>
          </div>
          <div class="stage-metrics">
            <div class="stage-title text-secondary mb-2">Breakthrough Incidents</div>
            <div class="stage-value h2 mb-2">
              {{ emailFunnel().total_breakthrough_incidents | number }}
            </div>
            <div
              class="stage-comparison small"
              [class.text-success]="
                (emailFunnel().total_breakthrough_incidents !== null ? emailFunnel().total_breakthrough_incidents : 0) <
                (emailFunnel().total_breakthrough_incidents_previous !== null
                  ? emailFunnel().total_breakthrough_incidents_previous
                  : 0)
              "
              [class.text-danger]="
                (emailFunnel().total_breakthrough_incidents !== null ? emailFunnel().total_breakthrough_incidents : 0) >
                (emailFunnel().total_breakthrough_incidents_previous !== null
                  ? emailFunnel().total_breakthrough_incidents_previous
                  : 0)
              "
            >
              @if (
                (emailFunnel().total_breakthrough_incidents !== null ? emailFunnel().total_breakthrough_incidents : 0) <
                (emailFunnel().total_breakthrough_incidents_previous !== null
                  ? emailFunnel().total_breakthrough_incidents_previous
                  : 0)
              ) {
                <span>↓</span>
              }
              @if (
                (emailFunnel().total_breakthrough_incidents !== null ? emailFunnel().total_breakthrough_incidents : 0) >
                (emailFunnel().total_breakthrough_incidents_previous !== null
                  ? emailFunnel().total_breakthrough_incidents_previous
                  : 0)
              ) {
                <span>↑</span>
              }
              {{ (emailFunnel().total_breakthrough_incidents_pct_change ?? 0) | number: '1.1-1' }}% vs previous
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
